import { RatingInputWUT } from '@wix/form-fields/viewer-wut';

export default RatingInputWUT;
